// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// import { getFirestore, collection, getDocs } from 'firebase/firestore/lite';
import { getDatabase } from "firebase/database";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyBAF7WOqnUrtoZWna0g6z9b0MoKrzuHG-g",
    authDomain: "p2t-publicc.firebaseapp.com",
    databaseURL: "https://p2t-publicc-default-rtdb.firebaseio.com",
    projectId: "p2t-publicc",
    storageBucket: "p2t-publicc.appspot.com",
    messagingSenderId: "788132200144",
    appId: "1:788132200144:web:1720d1146ad1ce4cc9e8d5",
    measurementId: "G-L86XGG9NQP"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const db = getDatabase();

export default db;